import React from 'react';

import { IPlansList20Fields } from '../../../types/contentful';

import { CollapsiblePlanInfo } from './CollapsiblePlanInfo';
import { BlockContainer, Column, Layout } from '../Layout';
import { Text } from '../Text';

interface Props extends IPlansList20Fields {
  sysId?: string;
}

export function CollapsiblePlansList({ plans, heading, sysId }: Props) {
  return (
    <BlockContainer
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-blockid={sysId}
      data-eltype="collapsible-plans-list"
      data-testid="collapsiblePlansList"
    >
      <Layout>
        {!!heading && (
          <Column size={{ 0: 11 }} marginBottom="l" justifyContent="center">
            <Text
              as="h2"
              fontWeight="h2"
              data-elementid="collapsible-plans-heading"
              textAlign="center"
              colour="defaultText"
              fontSize={{
                0: 'h2_0',
                tablet: 'h2_tablet',
                desktop: 'h2_desktop'
              }}
            >
              {heading || ''}
            </Text>
          </Column>
        )}
        {(plans || []).map(({ sys, fields }) => (
          <Column key={sys?.id} size={{ 0: 11, tablet: 7, desktop: 4 }}>
            <CollapsiblePlanInfo {...fields} />
          </Column>
        ))}
      </Layout>
    </BlockContainer>
  );
}
